import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SidebarContent from "./SidebarContent";
import { apiRemote } from "@/api";
import { useAlert } from "@/contexts/AlertContext";
import { useAvatar } from "@/contexts/AvatarContext";
import { useUser } from "@/contexts/UserContext";
import { CameraAltRounded } from "@mui/icons-material";
import he from "he";
// import './sidebar-select.scss';

// const drawerWidth = 250;

const Sidebar: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(250);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  var { user } = useUser();

  const { avatar, setAvatar } = useAvatar();
  const [loading, setLoading] = useState(false);
  const alert = useAlert();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (user?.avatar_url) {
      setAvatar(user?.avatar_url);
    }
  }, [user, setAvatar]);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("avatar", file);

      apiRemote
        .uploadAvatar({
          avatar: file,
        })
        .then((res) => {
          alert.success(res.update_message);
          if (res.avatar_url != "") {
            setAvatar(res.avatar_url);
          }
        })
        .catch((err) => {
          console.error("Update failed:", err);
        });
    } catch (error) {
      console.error("Error updating avatar:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: "flex",
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          position: "initial",
          width: drawerWidth,
          backgroundColor: "#f8fafc",
        },
      }}
      open
    >
      {/* <Toolbar /> */}
      <Box>
        <SidebarContent
          drawerWidth={drawerWidth}
          setDrawerWidth={setDrawerWidth}
        />
      </Box>
    </Drawer>
  );
};

export default Sidebar;
